export class DecimalRounding {
	protected constructor() {
	}

	static round(num: number, decimalPlaces: number): number {
		const p = Math.pow(10, decimalPlaces || 0);
		const n = (num * p) * (1 + Number.EPSILON);
		return Math.round(n) / p;
	}

	static ceil(num: number, decimalPlaces: number): number {
		const p = Math.pow(10, decimalPlaces || 0);
		const n = (num * p) * (1 - Math.sign(num) * Number.EPSILON);
		return Math.ceil(n) / p;
	}

	static floor(num: number, decimalPlaces: number): number {
		const p = Math.pow(10, decimalPlaces || 0);
		const n = (num * p) * (1 + Math.sign(num) * Number.EPSILON);
		return Math.floor(n) / p;
	}

	static trunc(num: number, decimalPlaces: number): number {
		return (num < 0 ? this.ceil : this.floor)(num, decimalPlaces);
	}

	static toFixed(num: number, decimalPlaces: number): string {
		return DecimalRounding.round(num, decimalPlaces).toFixed(decimalPlaces);
	}
}
